<template>
  <div>
    <v-divider class="mb-4"></v-divider>
    <v-row align="baseline" dense>
      <v-col cols="3">
        <span class="pr-4">Selecione o Plano</span>
        <v-btn small @click.native.stop="$refs.parentSearch.show">
          <v-icon small title="Buscar">fas fa-search</v-icon>
        </v-btn>
      </v-col>
      <parent-search
        :equivalenceId = "equivalenceId"
        :referencePlan="referencePlan"
        ref="parentSearch"
        @selected="selectPlan"
        title="Selecione uma Chave"
        :single="true"
      ></parent-search>
    </v-row>

    <v-row dense v-if="parentPlan">
      <v-col cols="2">
        <b>Atual:</b><br />
          <span v-if="parentPlan.currentPlan">
            {{ parentPlan.currentPlan.productCode }}-{{
              parentPlan.currentPlan.description
            }}
          </span>
      </v-col>
      <v-col cols="2">
        <b>Referência:</b><br />
        <span v-if="parentPlan.referencePlan">
          {{ parentPlan.referencePlan.productCode }}-{{
            parentPlan.referencePlan.description
          }}
         </span>
      </v-col>
      <v-col cols="2">
        <b>1° Proposto:</b><br />
        <span v-if="parentPlan.proposalPlanOne">
          {{
            parentPlan.proposalPlanOne.plan.productCode
          }}-{{ parentPlan.proposalPlanOne.plan.description }}
        </span>
      </v-col>
      <v-col cols="2">
        <b>2° Proposto:</b><br />
        <span v-if="parentPlan.proposalPlanTwo">
          {{
            parentPlan.proposalPlanTwo.plan.productCode
          }}-{{ parentPlan.proposalPlanTwo.plan.description }}
        </span>
      </v-col>
      <v-col cols="2">
        <b>3° Proposto:</b><br />
        <span v-if="parentPlan.proposalPlanThree">
          {{
            parentPlan.proposalPlanThree.plan.productCode
          }}-{{ parentPlan.proposalPlanThree.plan.description }}
        </span>
      </v-col>
      <v-col cols="2">
        <b>4° Proposto:</b><br />
        <span v-if="parentPlan.proposalPlanFour">
          {{
            parentPlan.proposalPlanFour.plan.productCode
          }}-{{ parentPlan.proposalPlanFour.plan.description }}
        </span>
      </v-col>
    </v-row>
    <v-row dense v-if="parentPlan">
      <v-col cols="2">
        <b>5° Proposto:</b><br />
        <span v-if="parentPlan.proposalPlanFive">
          {{
            parentPlan.proposalPlanFive.plan.productCode
          }}-{{ parentPlan.proposalPlanFive.plan.description }}
        </span>
      </v-col>
      <v-col cols="2"><b>Início:</b><br />{{ $util.formatDateToBR(parentPlan.startAt,true) }}</v-col>
      <v-col cols="2"><b>Fim:</b><br />{{ $util.formatDateToBR(parentPlan.endAt,true) }}</v-col>
      <v-col cols="1"
        ><b>Ativo:</b><br />{{ parentPlan.active ? 'Sim' : 'Não' }}</v-col
      >
    </v-row>
  </div>
</template>

<script>
import ParentSearch from '@/view/equivalence_configuration/components/dlg_parent_search';
import ProductService from '@/services/contract/ProductService';

const productService = new ProductService();

export default {
  components: {ParentSearch},

  props: {
    label: {
      type: String,
    },
    value: {
      type: Number,
    },
    errorMessages: {
      type: String,
    },
    referencePlan: {
      type: Object,
    },
    parentPlan: {
      type: Object,
    },
    equivalenceId: {
      type: Number
    }
  },

  data() {
    return {};
  },

  computed: {
    descPlan() {
      return this.plan ? this.plan.description : 'Selecione...';
    },
  },

  created() {
    if (this.value) {
      productService
        .findById(this.value)
        .then((result) => (this.plan = result.data));
    }
  },

  methods: {
    goBaßck() {
      this.$router.back();
    },

    selectPlan(products) {
      this.$emit('selected', products);
    },
    
  },
};
</script>
<style scoped>
</style>
